"use client";
import { TrackingContext } from "../contexts/tracking/TrackingContext.js";
import "react/jsx-runtime";
import { useContext } from "react";
const useTracking = () => {
  const context = useContext(TrackingContext);
  return context;
};
export {
  useTracking
};
